<template>
    <div :class="['fixed-top', {'non-fixed': isSticky}]">
        <div class="topbar">
            <div class="container">
                <div class="topbar-inner">
                    <div class="row justify-content-center justify-content-lg-between">
                        <div class="topbar-item topbar-left">
                            <ul class="topbar-list">
                                <li>
                                    <i class="icofont-headphone"></i>
                                    <a href="tel:+8618758065284">+86 18758065284</a>
                                </li>
                                <li>
                                    <i class="icofont-ui-message"></i>
                                    <a href="mailto:wendy@yogeeai.com">wendy@yogeeai.com</a>
                                </li>
                            </ul>
                        </div>
                        <div class="topbar-item topbar-right">
                            <ul class="topbar-list">
                                <li>
                                    <i class="icofont-paper-plane"></i>
                                    <router-link to="/contact">{{ $t('layout.navbar.topbarCta') }}</router-link>
                                </li>
                                <li
                                    class="lang-option"
                                    @click.stop="toggleLangMenu"
                                    @keydown.enter.prevent="toggleLangMenu"
                                    @keydown.space.prevent="toggleLangMenu"
                                    tabindex="0"
                                >
                                    <img v-lazy="$ossImg('nav/lang.svg')" alt="Language" class="lang-icon">
                                    <div class="lang-copy">
                                        <span class="lang-label">{{ $t('common.language.label') }}</span>
                                        <!-- <span class="lang-value">{{ languageLabel(currentLocale) }}</span> -->
                                    </div>
                                    <ul v-if="showLanguageMenu" class="lang-dropdown">
                                        <li
                                            v-for="option in languages"
                                            :key="option.code"
                                            @click.stop="changeLanguage(option.code)"
                                            :class="{ active: option.code === currentLocale }"
                                        >
                                            {{ languageLabel(option.code) }}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="['navbar-area sticky-black', {'is-sticky': isSticky}]">
            <div class="main-nav">
                <div class="container">
                    <nav class="navbar navbar-expand-md navbar-light">
                        <router-link class="navbar-brand" to="/">
                            <img v-lazy="$ossImg('logo.png')" alt="logo" class="logo">
                        </router-link>

                        <div 
                            class="navbar-toggler"
                            @click="active = !active" 
                            :aria-pressed="active ? 'true' : 'false'"
                            v-bind:class="{ 'active': button_active_state }"
                            v-on:click="button_active_state = !button_active_state"
                        >
                            <i class="icofont-navigation-menu"></i>
                            <i class="icofont-close"></i>
                        </div>

                        <div class="collapse navbar-collapse" :class="{ show: active }">
                            <ul class="navbar-nav mx-auto">
                                <!-- <li class="nav-item">
                                    <a href="#" class="nav-link dropdown-toggle">Home</a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item ">
                                            <router-link to="/" class="nav-link">
                                                Home Demo 1
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/home-two" class="nav-link">
                                                Home Demo 2
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/home-three" class="nav-link">
                                                Home Demo 3
                                            </router-link>
                                        </li>
                                    </ul>
                                </li> -->
                                <li class="nav-item">
                                    <a href="#" class="nav-link dropdown-toggle">{{ $t('layout.navbar.menu.products.label') }}</a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <router-link to="/product-one" class="nav-link">
                                               {{ $t('layout.navbar.menu.products.items.productOne') }}
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/product-two" class="nav-link">
                                                {{ $t('layout.navbar.menu.products.items.productTwo') }}
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/product-three" class="nav-link">
                                                {{ $t('layout.navbar.menu.products.items.productThree') }}
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/product-four" class="nav-link">
                                                {{ $t('layout.navbar.menu.products.items.productFour') }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- <li class="nav-item">
                                    <router-link to="/about-us" class="nav-link">
                                        About Us
                                    </router-link>
                                </li> -->
                                <li class="nav-item">
                                    <a href="#" class="nav-link dropdown-toggle">{{ $t('layout.navbar.menu.scenarios.label') }}</a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <router-link to="/service-one" class="nav-link">
                                                {{ $t('layout.navbar.menu.scenarios.items.scenarioOne') }}
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/service-two" class="nav-link">
                                                {{ $t('layout.navbar.menu.scenarios.items.scenarioTwo') }}
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/service-three" class="nav-link">
                                                {{ $t('layout.navbar.menu.scenarios.items.scenarioThree') }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- <li class="nav-item">
                                    <a href="#" class="nav-link dropdown-toggle">Services</a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <router-link to="/services" class="nav-link">
                                                Services
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/single-services" class="nav-link">
                                                Single Service
                                            </router-link>
                                        </li>
                                    </ul>
                                </li> -->
                                <!-- <li class="nav-item">
                                    <a href="#" class="nav-link dropdown-toggle">Pages</a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <router-link to="/pricing" class="nav-link">
                                                Pricing
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/faqs" class="nav-link">
                                                FAQ's
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/our-team" class="nav-link">
                                                Our Team
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <a href="#" class="nav-link dropdown-toggle">Projects</a>
                                            <ul class="dropdown-menu">
                                                <li class="nav-item">
                                                    <router-link to="/projects" class="nav-link">
                                                        Projects
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/single-project" class="nav-link">
                                                        Single Project
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a href="#" class="nav-link dropdown-toggle">Case Study</a>
                                            <ul class="dropdown-menu">
                                                <li class="nav-item">
                                                    <router-link to="/cases" class="nav-link">
                                                        Case
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/cases-two-columns" class="nav-link">
                                                        Cases Two Columns
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/single-case" class="nav-link">
                                                        Single Case
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/testimonial" class="nav-link">
                                                Testimonial
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/our-clients" class="nav-link">
                                                Our Clients
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/careers" class="nav-link">
                                                Careers
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <a href="#" class="nav-link dropdown-toggle">Products</a>
                                            <ul class="dropdown-menu">
                                                <li class="nav-item">
                                                    <router-link to="/products" class="nav-link">
                                                        Products
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/single-product" class="nav-link">
                                                        Single Product
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/cart" class="nav-link">
                                                        Cart
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/checkout" class="nav-link">
                                                        Checkout
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a href="#" class="nav-link dropdown-toggle">Users</a>
                                            <ul class="dropdown-menu">
                                                <li class="nav-item">
                                                    <router-link to="/authentication" class="nav-link">
                                                        Authentication
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/forget-password" class="nav-link">
                                                        Forget Password
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/my-account" class="nav-link">
                                                        My Account
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/my-orders" class="nav-link">
                                                        My Orders
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/my-addresses" class="nav-link">
                                                        My Addresses
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a href="#" class="nav-link dropdown-toggle">Others</a>
                                            <ul class="dropdown-menu">
                                                <li class="nav-item">
                                                    <router-link to="/demo-product" class="nav-link">
                                                        Demo Product
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/feedback" class="nav-link">
                                                        Feedback
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/terms-of-service" class="nav-link">
                                                        Terms Of Service
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/privacy-policy" class="nav-link">
                                                        Privacy Policy
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/search-page" class="nav-link">
                                                        Search Page
                                                    </router-link>
                                                </li>
                                                <li class="nav-item">
                                                    <router-link to="/coming-soon" class="nav-link">
                                                        Coming Soon
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a href="#" class="nav-link dropdown-toggle">Blogs</a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item">
                                            <router-link to="/blogs" class="nav-link">
                                                Blogs Grid
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/blogs-right-sidebar" class="nav-link">
                                                Blogs Right Sidebar
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link to="/single-blog" class="nav-link">
                                                Single Blog
                                            </router-link>
                                        </li>
                                    </ul>
                                </li> -->
                               
                                <li class="nav-item">
                                    <router-link to="/news" class="nav-link">
                                        {{ $t('layout.navbar.menu.news') }}
                                    </router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link to="/about-us" class="nav-link">{{ $t('layout.navbar.menu.about') }}</router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="navbar-option">
                            <div class="navbar-option-item">
                                <router-link to="/contact" class="btn main-btn">
                                    {{ $t('layout.navbar.cta') }}
                                </router-link>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    data(){
        return {
            isSticky: false,
            isMenu: false,
            active: false,
            button_active_state: false,
            showLanguageMenu: false,
            languages: [
                { code: 'zh', labelKey: 'common.language.options.zh' },
                { code: 'en', labelKey: 'common.language.options.en' }
            ],
            scrollHandler: null,
        }
    },
    computed: {
        currentLocale() {
            if (this.$y18n && this.$y18n.locale) {
                return this.$y18n.locale.value
            }
            return typeof this.$getLang === 'function' ? this.$getLang() : 'zh'
        }
    },
    methods: {
        handleScroll() {
            const scrollPos = window.scrollY
            this.isSticky = scrollPos >= 100
        },
        toggleLangMenu() {
            this.showLanguageMenu = !this.showLanguageMenu
        },
        closeLangMenu() {
            this.showLanguageMenu = false
        },
        changeLanguage(locale) {
            if (typeof this.$setLang === 'function') {
                this.$setLang(locale)
            }
            this.showLanguageMenu = false
        },
        languageLabel(code) {
            return this.$t(`common.language.options.${code}`) || code
        }
    },
    mounted(){
        this.scrollHandler = this.handleScroll
        window.addEventListener('scroll', this.scrollHandler)
        document.addEventListener('click', this.closeLangMenu)
    },
    beforeUnmount() {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler)
        }
        document.removeEventListener('click', this.closeLangMenu)
    }
}
</script>

<style scoped>
.lang-option {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    cursor: pointer;
}

.lang-option:focus {
    outline: none;
}

.lang-copy {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.lang-label {
    font-size: 12px;
    color: #767676;
}

.lang-value {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.lang-dropdown {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    min-width: 140px;
    padding: 8px 0;
    list-style: none;
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
    z-index: 10;
}

.lang-dropdown li {
    padding: 8px 16px;
    font-size: 14px;
    color: #1d1d1f;
    transition: background 0.2s ease, color 0.2s ease;
    margin-right: 0;
    border: 0;
}

.lang-dropdown li:hover,
.lang-dropdown li.active {
    background: rgba(11, 113, 250, 0.08);
    color: #0B71FA;
    font-weight: 600;
}

.navbar-option .main-btn {
    transition: all 0.5s ease-in-out;
    background-color: #0B71FA;
    color: white;
}

.navbar-option .main-btn:hover {
    background: linear-gradient(90deg, #0B71FA 0%, #FF94C8 100%);
    color: white;
    border: none;
}
.logo {
    width: 150px;
    height: 30px;
}
</style>
